"use client"

import { create } from "zustand"
import { Button } from "@/src/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/src/components/ui/dialog"

interface NavigateState {
  canNavigate: boolean
  showAlertWindow: boolean
  confirmCallback?: () => void
  setCanNavigate: (canNavigate: boolean) => void
  showNavigateAlert: (onConfirm?: () => void) => void
  closeAlert: () => void
  confirmNavigation: () => void
}

export const useNavigateStore = create<NavigateState>((set) => ({
  canNavigate: true,
  showAlertWindow: false,
  confirmCallback: undefined,
  setCanNavigate: (canNavigate: boolean) => set({ canNavigate }),
  showNavigateAlert: (onConfirm?: () => void) => set({ showAlertWindow: true, confirmCallback: onConfirm }),
  closeAlert: () => set({ showAlertWindow: false }),
  confirmNavigation: () =>
    set((state) => {
      if (state.confirmCallback) {
        state.confirmCallback()
      }
      return { canNavigate: true, showAlertWindow: false, confirmCallback: undefined }
    }),
}))

export function NavigateDialog() {
  const showAlertWindow = useNavigateStore((state) => state.showAlertWindow)
  const closeAlert = useNavigateStore((state) => state.closeAlert)
  const confirmNavigation = useNavigateStore((state) => state.confirmNavigation)

  return (
    <Dialog open={showAlertWindow} onOpenChange={(open) => !open && closeAlert()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Unsaved Changes</DialogTitle>
          <DialogDescription>
            You have unsaved changes. If you leave this page now, any unsaved changes will be lost. Are you
            sure you want to leave without saving?
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-3">
          <Button variant={"outline"} onClick={closeAlert}>
            Cancel
          </Button>
          <Button onClick={confirmNavigation}>Leave without saving</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
